<template>
  <div
    v-if="brandSneakPeek"
    class="sneak-peek"
  >
    <div
      class="sneak-peek__background"
      :style="`background: url(${getImageLarge}) center center / cover no-repeat;`"
    />
    <div class="sneak-peek__overlay" />
    <div class="sneak-peek__left">
      <SneakPeekInfo
        :brand-sneak-peek="brandSneakPeek"
        :carousel-uuid="carouselUuid"
      />
    </div>
    <div class="sneak-peek__right">
      <div class="items-container">
        <slot name="SneakPeekTile" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SneakPeekInfo from '@bc/discovery/feature/brands-sneak-peek/components/sneak-peek-info.vue';
import { SneakPeekBrand } from '@client/modules/discovery/feature/brands-sneak-peek/types/types';
const props = defineProps<{
  brandSneakPeek: SneakPeekBrand;
  carouselUuid?: string;
}>();
const getImageLarge = computed(() => {
  // Try brand_images first, fallback to brand_logo
  const imageUrl = props.brandSneakPeek?.brand_images?.[0]?.src || props.brandSneakPeek?.brand_logo;
  return imageUrl;
});
</script>

<style scoped lang="scss">
.sneak-peek {
  @apply ds-w-full ds-mt-4 ds-flex ds-flex-col lg:ds-flex-row ds-relative ds-rounded-lg ds-z-10;
  overflow: hidden;
  &__background {
    @apply ds-absolute;
    filter: blur(3px);
    -webkit-filter: blur(3px);
    inset: 0rem;
  }
  &__overlay {
    @apply ds-absolute;
    background: rgba(255, 255, 255, 0.6);
    inset: 0rem;
    z-index: 1;
  }
  &__left {
    @apply ds-w-full ds-p-5 lg:ds-w-[536px] lg:ds-p-6 ds-bg-warm-100 ds-z-20 ds-opacity-90;
  }
  &__right {
    @apply ds-w-full ds-flex ds-items-center ds-justify-center ds-p-4;
  }
  .items-container {
    @apply ds-grid ds-grid-cols-2  ds-z-20 ds-gap-4 lg:ds-grid-cols-4 ds-w-full ds-h-full ds-justify-start;
  }
}
</style>
